import Model from "./model";

const NOTIFICATION_TYPE_CD = {
  NOTIFICATION: "0",
  ERROR: "1",
  CAUTION: "2",
};

class Notification extends Model {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();

    this._notificationTypeCd;
    this._title;
    this._message;
  }
  /* eslint-enable */

  get notificationTypeCd() {
    return this._notificationTypeCd;
  }

  set notificationTypeCd(value) {
    this._notificationTypeCd = value;
  }

  get title() {
    return this._title;
  }

  set title(value) {
    this._title = value;
  }

  get message() {
    return this._message;
  }

  set message(value) {
    this._message = value;
  }
}

export {
  Notification,
  NOTIFICATION_TYPE_CD,
};
